import React, { useState } from 'react'
import { Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography, Container } from '@material-ui/core'
import axios from 'axios'
import dataService from '../services/dataService'
import countrylist from '../assets/countrylist.json'
import FadeIn from 'react-fade-in/lib/FadeIn'
import img5 from '../assets/azimuth.png'

const SolarEnergyCalculator = () => {

  const [ city, setCity ] = useState('')
  const [ selectedCity, setSelectedCity ] = useState('')
  const [ integer, setInteger ] = useState('')
  const [ cost, setCost ] = useState('')
  const [ rate, setRate ] = useState('')
  const [ life, setLife ] = useState('')
  const [ buyPrice, setBPrice ] = useState('')
  const [ sellPrice, setSPrice ] = useState('')
  const [ interest, setInterest ] = useState('')
  const [ mAverages, setMAverages ] = useState([])
  const [ totals, setTotals ] = useState({})
  const [ isLoading, setIsLoading ] = useState(false)
  const [ countries, setCountries ] = useState({})
  const [ inputs, setInputs ] = useState({})
  const [ message, setMessage ] = useState('')
  console.log(selectedCity)


  // Event-funktio hakee formin sijaintiarvojen avulla koordinaatit OpenWeatherMapista
  // Sitten jos koordinaatit löytyy, kutsutaan funktiota, joka hakee rajapinnasta json-muodossa dataa
  const onSubmitSolarForm = async (e) => {
    e.preventDefault()
    setMessage('')
    setIsLoading(true)
    try {
      const req = await axios.get(`https://api.openweathermap.org/geo/1.0/direct?q=${city},${countries.code}&appid=e190e9cf69b53677a62d47b93a7e0ce5`)
      if(req.data.length === 0) {
        setMessage('No city found, try another query')
        setIsLoading(false)
        setMAverages([])
        setTotals({})
        setInputs({})
      } else {
        setSelectedCity(req.data)
        const rad = await dataService.getRadiation(req.data[0].lat, req.data[0].lon, integer, cost, interest, life)
        if(rad) {
          console.log(rad)
          setMAverages(rad.outputs.monthly.fixed)
          setTotals(rad.outputs.totals.fixed)
          setInputs(rad.inputs)

          setIsLoading(false)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <FadeIn transitionDuration="3000">
      <div>
        <Typography variant="h3" style={{ color:'white' }}>Solar Energy Calculator<br></br><br></br></Typography>
        <Container>
          <div style={{
            float:'left',
            width:'50%'
          }}>
            <div className="Pilot-areas">
              <Typography variant="subtitle1"> </Typography>
              <Typography variant="subtitle1">Disclaimer: Results of this calculator are only estimates. <br></br> <br></br>Normal household&#39;s installed kWp is usually 5-10 kWp and self-utilization rate is between 60% and 80%.<br></br><br></br>The Cost of PV system mean whole cost of buying and installing the PV system, in your currency. If you entered 5 kWp as the installed kWp, the cost should be for a system of that size. Cost is based on the fact that PV system is payed by mortage. The interest rate is assumed to be constant throughout the lifetime of the PV system.<br></br><br></br>Selling price of electricity is the spot price and buying price includes energy, distribution, and tax.</Typography>
              <br></br>
            </div>
          </div>
        </Container>
        <form style={{
          float:'right',
          width:'50%'
        }}>
          <FormControl style={{
            fontSize:'25px',
            minWidth:'250px',
            background:'white',
            color:'black'
          }}>
            <InputLabel>Select Country</InputLabel>
            <Select
              required
              value={countries}
              onChange={(e) => setCountries(e.target.value)}
            >
              {
                countrylist.map(c =>
                  <MenuItem key={c.id} value={c}>{c.name}</MenuItem>
                )
              }
            </Select>
          </FormControl>

          <div>
            <input
              placeholder="City"
              required type="text"
              value={city}
              style={{
                fontSize:'25px',
                minWidth:'250px',
                border:'1px solid white',
                margin:'1%'
              }}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>
          <div>
            <input
              placeholder="Installed kWp"
              required type="number"
              style={{
                fontSize:'25px',
                minWidth:'250px',
                border:'1px solid white',
                margin:'1%'
              }}
              value={integer}
              onChange={(e) => setInteger(e.target.value)}
            />


            <input
              placeholder="Cost of PV system (€)"
              required type="number"
              style={{
                fontSize:'25px',
                minWidth:'250px',
                border:'1px solid white',
                margin:'1%'
              }}
              value={cost}
              onChange={(e) => setCost(e.target.value)}
            />
            <input
              placeholder="PV system lifetime (years)"
              required type="number"
              style={{
                fontSize:'25px',
                minWidth:'250px',
                border:'1px solid white',
                margin:'1%'
              }}
              value={life}
              onChange={(e) => setLife(e.target.value)}
            />

            <input
              placeholder="Interest in %/year"
              required type="number"
              style={{
                fontSize:'25px',
                minWidth:'250px',
                border:'1px solid white',
                margin:'1%'
              }}
              value={interest}
              onChange={(e) => setInterest(e.target.value)}
            />
            <input
              placeholder="Self-utilization rate (%)"
              required type="number"
              style={{
                fontSize:'25px',
                minWidth:'250px',
                border:'1px solid white',
                margin:'1%'
              }}
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />
          </div>
          <div>
            <input
              placeholder="Electricity buying price (snt)"
              required type="number"
              style={{
                fontSize:'25px',
                minWidth:'250px',
                border:'1px solid white',
                margin:'1%'
              }}
              value={buyPrice}
              onChange={(e) => setBPrice(e.target.value)}
            />
            <input
              placeholder="Electricity selling price (snt)"
              required type="number"
              style={{
                fontSize:'25px',
                minWidth:'250px',
                border:'1px solid white',
                margin:'1%'
              }}
              value={sellPrice}
              onChange={(e) => setSPrice(e.target.value)}
            />

          </div>
          <Button onClick={onSubmitSolarForm}
            style={{
              fontSize:'15px',
              color: 'white',
              background:'black',
              minWidth:'250px',
              border:'1px solid white',
              margin:'1%'
            }}>Go!</Button>
        </form>
        {
          message ?
            <Typography variant="h5">{message}</Typography> : <p></p>
        }
        {
          isLoading ?
            <CircularProgress />
            : mAverages.length && inputs ?
              <div>
                <div className="Home-header2">
                  {
                    <div>
                      <Typography variant="h5">Input parameters</Typography>
                      <Typography variant="h6">Optimal azimuth, Gives highest energy output for the whole year: {inputs.mounting_system.fixed.azimuth.value}°</Typography>
                      <Typography variant="h6">Optimal slope, Gives highest energy output for the whole year: {inputs.mounting_system.fixed.slope.value}°</Typography>
                      <div className="hover_img">
                        <a href="#">Explanation image of azimuth<span><img src={img5} alt="image" height="200" /></span></a>
                      </div>
                    </div>
                  }
                </div>
                <div className="Home-header">
                  <u><Typography variant="h5" style={{ textTransform: 'capitalize' }}>Results in {selectedCity[0].name}, {selectedCity[0].country}</Typography></u>
                  {
                    mAverages.map(m =>
                      <Typography key={m.month}>{new Date(2022, (m.month - 1), 1).toLocaleString('default', { month: 'long' })}: {parseFloat(m.E_m).toFixed(1)} kWh</Typography>
                    )
                  }
                  {
                    <Typography variant="h5">Annual yield: {totals.E_y} kWh</Typography>
                  }
                  {
                    <Typography variant="h5">Self-production price: {totals.LCOE_pv} €/kWh</Typography>
                  }
                  {

                    <Typography variant="h5">Investment payback time: {(cost / ((((buyPrice/100) - totals.LCOE_pv) * totals.E_y * (rate/100)) + (totals.E_y * (1-(rate/100)) * ((sellPrice/100) - totals.LCOE_pv)))).toFixed(1) } years</Typography>
                  }

                </div>
              </div> : <p></p>
        }
      </div>
    </FadeIn>
  )
}

export default SolarEnergyCalculator